import { render } from "./RiFloatingBtn.vue?vue&type=template&id=5c0ea1b9"
import script from "./RiFloatingBtn.vue?vue&type=script&lang=js"
export * from "./RiFloatingBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiFloatingBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c0ea1b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c0ea1b9', __exports__)) {
    api.reload('5c0ea1b9', __exports__)
  }
  
  module.hot.accept("./RiFloatingBtn.vue?vue&type=template&id=5c0ea1b9", () => {
    api.rerender('5c0ea1b9', render)
  })

}


export default __exports__